import { render, staticRenderFns } from "./NavbarGroup.vue?vue&type=template&id=47ad7cf4"
import script from "./NavbarGroup.vue?vue&type=script&lang=js"
export * from "./NavbarGroup.vue?vue&type=script&lang=js"
import style0 from "./NavbarGroup.vue?vue&type=style&index=0&id=47ad7cf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports